(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-hero"] && !Shopify.designMode) return;
  try {
    
function initSpHeroSlides(){
document.querySelectorAll('[data-sp-carousel]').forEach(root=>{
if(root.dataset.initialized)return;root.dataset.initialized='true';
const slides=Array.from(root.querySelectorAll('[data-slide]'));if(slides.length<2)return;
const dots=Array.from(root.querySelectorAll('[data-dot]'));const pause=root.querySelector('[data-pause]');let index=0,timer=null,userPaused=false,hovered=false,focused=false,editorSelected=false;
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');const enabled=root.dataset.autoplay==='true'&&root.dataset.editor!=='true'&&!reduced.matches;const delay=Number(root.dataset.interval)||6000;
const show=n=>{index=(n+slides.length)%slides.length;slides.forEach((s,i)=>{s.hidden=i!==index;});dots.forEach((d,i)=>{if(i===index)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current');});root.querySelector('[data-counter]').textContent=String(index+1).padStart(2,'0')+' / '+slides.length;slides[(index+1)%slides.length].querySelectorAll('img').forEach(img=>{img.loading='eager';});};
const stop=()=>{if(timer)clearInterval(timer);timer=null;};
const start=()=>{stop();if(enabled&&!userPaused&&!hovered&&!focused&&!editorSelected&&!document.hidden)timer=setInterval(()=>show(index+1),delay);};
root.querySelector('[data-prev]').addEventListener('click',()=>{show(index-1);start();});root.querySelector('[data-next]').addEventListener('click',()=>{show(index+1);start();});dots.forEach((d,i)=>d.addEventListener('click',()=>{show(i);start();}));
pause.addEventListener('click',()=>{userPaused=!userPaused;pause.setAttribute('aria-pressed',String(userPaused));pause.setAttribute('aria-label',userPaused?root.dataset.playLabel:root.dataset.pauseLabel);pause.textContent=userPaused?'▷':'Ⅱ';start();});
if(!enabled)pause.hidden=true;
root.addEventListener('mouseenter',()=>{hovered=true;stop();});root.addEventListener('mouseleave',()=>{hovered=false;start();});root.addEventListener('focusin',()=>{focused=true;stop();});root.addEventListener('focusout',e=>{if(!root.contains(e.relatedTarget)){focused=false;start();}});
root.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){e.preventDefault();show(index-1);start();}if(e.key==='ArrowRight'){e.preventDefault();show(index+1);start();}});
let touchX=null;root.addEventListener('touchstart',e=>{touchX=e.changedTouches[0].clientX;stop();},{passive:true});root.addEventListener('touchend',e=>{if(touchX!==null){const delta=e.changedTouches[0].clientX-touchX;if(Math.abs(delta)>50)show(index+(delta<0?1:-1));touchX=null;start();}},{passive:true});
const select=e=>{const i=slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0){editorSelected=true;stop();show(i);}};const visibility=()=>start();document.addEventListener('shopify:block:select',select);document.addEventListener('visibilitychange',visibility);
root.spCleanup=()=>{stop();document.removeEventListener('shopify:block:select',select);document.removeEventListener('visibilitychange',visibility);};show(0);start();
});}
initSpHeroSlides();document.addEventListener('shopify:section:load',initSpHeroSlides);document.addEventListener('shopify:section:unload',e=>{e.target.querySelectorAll('[data-sp-carousel]').forEach(r=>r.spCleanup?.());});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["succrealpu-home"] && !Shopify.designMode) return;
  try {
    
function initSuccrealpu(){
  document.querySelectorAll('.sp-home').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const openHash=()=>{
      const id=decodeURIComponent(location.hash.slice(1));
      const target=document.getElementById(id);
      root.querySelectorAll('dialog[open]').forEach(d=>{if(d!==target)d.close();});
      if(target&&root.contains(target)&&target.tagName==='DIALOG'&&!target.open){target.showModal();}
      if(target&&target.tagName==='DETAILS'){target.open=true;target.scrollIntoView({behavior:'smooth',block:'center'});}
    };
    root.querySelectorAll('dialog').forEach(d=>{
      d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom){d.close();history.replaceState(null,'',location.pathname+location.search+'#sp-collections');}}});
      d.addEventListener('cancel',()=>history.replaceState(null,'',location.pathname+location.search+'#sp-collections'));
    });
    root.addEventListener('click',e=>{const a=e.target.closest('a[href^="#"]');if(a&&a.hash===location.hash){openHash();}});
    window.addEventListener('hashchange',openHash);
    openHash();
  });
}
initSuccrealpu();
document.addEventListener('shopify:section:load',initSuccrealpu);

  } catch(e) { console.error(e); }
})();
})();
